module.exports = __webpack_public_path__ + "static/media/footer-facebook.aa5e120b.svg";